<template>
  <div class="modal-mask"
       title="Close Image"
       @keyDown.left="$emit('moveLeft')"
       @keyDown.right="$emit('moveRight')"
       @keyDown.esc="$emit('close')"
       @click.self="$emit('close')">
    <div class="modal-container" title="">
      <button type="button" class="close-button" @click="$emit('close')">X</button>
      <div class="modal-body">
        <div class="image-container">
          <img :title="piece.label" :alt="piece.label" class="modal-img" v-bind:src="urlPrefix + piece.url">
          <button class="direction-button left"
                  type="button"
                  @click="$emit('moveLeft')">
            Previous
          </button>
          <button class="direction-button right" type="button"
                  @click="$emit('moveRight')">
            Next
          </button>
        </div>
        <div class="modal-text">
          {{ piece.label }}
        </div>
        <div class="modal-text">
          {{ piece.size }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.keyListener = this.onKeyDown.bind(this);
    window.addEventListener('keydown', this.keyListener);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.keyListener);
  },
  methods: {
    onKeyDown(event) {
      if (event.key === 'ArrowLeft') {
        this.$emit('moveLeft');
      } else if (event.key === 'ArrowRight') {
        this.$emit('moveRight');
      } else if (event.key === 'Escape') {
        this.$emit('close');
      }
    },
  },
  props: ['piece', 'urlPrefix'],
  data() {
    return {
      keyListener: null,
    };
  },
};
</script>

<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s ease;
  display: flex;
  cursor: pointer;
  justify-content: center;
}
.modal-container {
  align-self: center;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  cursor: auto;

  display: flex;
  flex-direction: column;
}
.modal-body {
  img {
    min-width: 30vw;
    min-height: 30vw;
    max-width: 80vw;
    max-height: 60vh;
    display: block;
  }
  .modal-text {
    padding: 0.5em;
    font-size: 1.5rem;
  }
}
.close-button {
  position: absolute;
  right: 0;
  top: 0;
  background: transparent;
  border: transparent;
  font-size: 2rem;
  opacity: 0.5;
  cursor: pointer;
}
.image-container {
  position: relative;
  padding: 0;
}
.direction-button {
  position: absolute;
  width: 30%;
  min-width: 5em;
  height: 100%;
  bottom: 0;
  background: transparent;
  opacity: 0;
  border: transparent;
  outline: transparent;
  font-size: 1.5rem;
  cursor: pointer;

  &:hover {
    background: rgba(0, 0, 0, 0.1);
    color: #fff;
    opacity: 1;
  }

  &.left {
    left: 0;
  }

  &.right {
    right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue?017407be